import { SET_NEW_BUILD_AVAILABLE } from '../types';

export default function setNewBuildAvailable(state=false, action) {
    switch(action.type) {
        case SET_NEW_BUILD_AVAILABLE:
            return action.payload.isNewBuildAvailable;
        default:
            return state;
    }
}